import {Injectable} from '@angular/core';

import {AuthenticationService} from '../services/authentication.service';

@Injectable({
    providedIn: 'root'
})
/**
 * Regelt die Authentifizierung für Platin User
 */
export class PlatinumGuard 
{
    constructor(private authenticationService: AuthenticationService)
    {
    }

    /**
     * Gibt einen bool zurück der angibt ob der User das Element aktivieren darf
     */
    canActivate(): boolean
    {
        return this.authenticationService.isPlatinum();
    }

    /**
     * Gibt einen bool zurück der angibt ob der User das Element laden darf
     */
    canLoad(): boolean
    {
        return this.authenticationService.isPlatinum();
    }
}
